import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3158fd18"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "media" };
const _hoisted_2 = { class: "media-content" };
const _hoisted_3 = { class: "content" };
const _hoisted_4 = { class: "level is-mobile mb-2" };
const _hoisted_5 = { class: "level-left taskHeader" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-envelope mr-2" }, null, -1));
const _hoisted_7 = {
    key: 0,
    class: "tag is-info is-rounded has-text-weight-bold ml-3"
};
const _hoisted_8 = {
    key: 1,
    class: "tag is-info is-rounded has-text-weight-bold ml-3"
};
const _hoisted_9 = {
    key: 2,
    class: "tag is-light is-rounded has-text-weight-bold ml-3"
};
const _hoisted_10 = {
    key: 3,
    class: "tag is-warning is-rounded has-text-weight-bold ml-3"
};
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-camera mr-2" }, null, -1));
const _hoisted_12 = {
    key: 4,
    class: "tag is-primary is-rounded has-text-weight-bold ml-3"
};
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-share mr-2" }, null, -1));
const _hoisted_14 = {
    key: 5,
    class: "tag is-danger is-rounded has-text-weight-bold ml-3"
};
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1));
const _hoisted_16 = { class: "taskFooter" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-clock mr-1 mt-2 ml-5" }, null, -1));
const _hoisted_18 = { key: 0 };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-clock mr-1 mt-2 ml-5" }, null, -1));
import { enumKey, formatTimeRelativeToNow } from "@/core/utils";
import { Core } from "@minicity/core";
import { InboundMailItemStatus } from "./model";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InboundMailItemWidget',
    props: {
        item: {},
        highlighted: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["box itemWidget p-3", { 'highlighted': _ctx.highlighted }])
            }, [
                _createElementVNode("article", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("span", _hoisted_5, [
                                        _hoisted_6,
                                        (_ctx.item.label)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.item.label), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_8, " Mail Item " + _toDisplayString(_ctx.item.id), 1)),
                                        (_ctx.item.entityType)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(enumKey)(_ctx.item.entityType, _unref(Core).EntityType)) + " " + _toDisplayString(_ctx.item.entityDescription ? ` - ${_ctx.item.entityDescription}` : ''), 1))
                                            : _createCommentVNode("", true),
                                        (!_ctx.item.scannedAt)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                                _hoisted_11,
                                                _createTextVNode("Scan Pending ")
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_ctx.item.status == _unref(InboundMailItemStatus).FORWARDED)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                                _hoisted_13,
                                                _createTextVNode("Forwarded ")
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_ctx.item.status == _unref(InboundMailItemStatus).TRASHED)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                                _hoisted_15,
                                                _createTextVNode("Destroyed ")
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                    _hoisted_17,
                                    _createElementVNode("strong", null, "Received " + _toDisplayString(_unref(formatTimeRelativeToNow)(_ctx.item.receivedAt)), 1),
                                    (_ctx.item.scannedAt)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                            _hoisted_19,
                                            _createElementVNode("strong", null, "Scanned " + _toDisplayString(_unref(formatTimeRelativeToNow)(_ctx.item.scannedAt)), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ])
                    ])
                ])
            ], 2));
        };
    }
});
